import { defineStore } from "pinia"
import { useAppStore } from "./app"
import { useUserStore } from "./user"


export const usePhoneNumbersStore = defineStore("phone_numbers", {
    state: () => {
        return {
            numbers: {},
            loading: false,
            app: null,
            user: null,
            phone_settings: {
                sid: null,
                use_custom_settings: true,
                forwarding_phone_number: "",
                caller_id: "caller",
                forward_sms_messages: false,
                send_call_notification_sms: false,
                press_key_to_connect: false,
                whisper_lead_info: false,
                record: false,
                voice_redirect_url: "",
                sms_redirect_url: ""
            },
            loading_phone_settings: false,
            saving_phone_settings: false
        }
        
    },
    actions: {
        fetchPhoneNumbers () {
            this.app = useAppStore()
            this.user = useUserStore()
            this.loading = true
            this.app.req.get('user/phone_numbers')
                .then(data => {
                    this.numbers = data.incoming_phone_numbers
                    this.loading = false
                })
                .catch(error => {
                    if(error.code == 'phone_credentials_missing')
                        this.user.show_user_settings = true
                    this.app.showError(error.message)
                    this.loading = false
                })
        },
        fetchPhoneSettings (sid = null) {
            this.app = useAppStore()
            this.user = useUserStore()
            this.loading_phone_settings = true

            // if sid is null, get the general default settings
            let url = sid == null ? 'user/phone_settings' : `phone/${sid}/settings`

            this.app.req.get(url)
                .then(data => {
                    if(data !== "")
                        this.phone_settings = data
                    this.loading_phone_settings = false
                })
                .catch(error => {
                    this.app.showError(error.message)
                    this.loading_phone_settings = false
                })
        },
        savePhoneSettings (sid = null) {
            console.log("save sid", sid, this.phone_settings)
            // return
            
            this.app = useAppStore()
            this.saving_phone_settings = true

            let url = sid == null ? 'user/phone_settings' : `phone/${sid}/settings`

            this.app.req.post(url, this.phone_settings)
                .then(data => {
                    this.saving_phone_settings = false
                })
                .catch(error => {
                    this.app.showError(error.message)
                    this.saving_phone_settings = false
                })
        },
        saveFriendlyName(phone_number) {
            this.saving_phone_settings = true
            this.app.req.post(`phone/${phone_number.sid}/friendly_name`, phone_number)
                .then(data=> {
                    this.saving_phone_settings = false
                })
                .catch(error => {
                    this.app.showError(error.message)
                    this.saving_phone_settings = false
                })
        }
    }
})